import React from "react";
import { useAuth } from "../hooks/useAuth";
import { authService } from "../services/auth";
import { ADMIN_STRINGS } from "../constants/strings";
import { Button } from "../ui";

export default function ImpersonationBanner() {
  const { user } = useAuth();
  const isImpersonating = !!user?.impersonatedBy;
  if (!isImpersonating) return null;

  const handleReturn = async () => {
    try {
      await authService.refreshToken();
      window.location.href = "/cx";
    } catch {
      window.location.href = "/login";
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1400,
        background: "var(--warn)",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        padding: "6px 16px",
      }}
    >
      <span style={{ fontSize: 13, fontWeight: 600 }}>
        {ADMIN_STRINGS.IMPERSONATE_BANNER} {user?.firstName} {user?.lastName}
      </span>
      <Button variant="outline" size="sm" onClick={handleReturn}>
        {ADMIN_STRINGS.IMPERSONATE_RETURN}
      </Button>
    </div>
  );
}
